module.exports = __webpack_public_path__ + "img/cheminee.7840210c.jpg";